import React from 'react';
import styles from './languageChooser.module.css';
import huIcon from '../../../assets/icons/hu.png';
import enIcon from '../../../assets/icons/en.png';
import { useTranslation } from 'react-i18next';

const LanguageChooser = () => {
  const languages = { en: enIcon, hu: huIcon };
  const { i18n, ready } = useTranslation();

  const setNewLanguage = () => {
    if (!ready) return; // Don't change language while loading

    const currentLanguage = i18n.language || localStorage.getItem('lng') || 'hu';
    const newLanguage = currentLanguage === 'en' ? 'hu' : 'en';

    i18n.changeLanguage(newLanguage);
    localStorage.setItem('lng', newLanguage);
  };

  // Show loading state or current language icon
  const currentLanguage = i18n.language || localStorage.getItem('lng') || 'hu';
  const icon = languages[currentLanguage];

  return (
    <div
      onClick={setNewLanguage}
      className={styles.lang_chooser}
      style={{ background: `url(${icon})` }}
      title={currentLanguage === 'en' ? 'Switch to Hungarian' : 'Switch to English'}
    />
  );
};

export default LanguageChooser;
